module.exports = __webpack_public_path__ + "img/89.10.pH.7fff3111.png";